/**
 * Substitui `next/dist/build/polyfills/polyfill-module`, que o Next embute no
 * bundle de cliente com 9 polyfills — dos quais só este é necessário para o
 * baseline suportado (Safari 12 / Chrome 69).
 */
if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: (target: unknown, key: PropertyKey): boolean => {
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object')
      }

      return Object.prototype.hasOwnProperty.call(Object(target), key)
    },
    configurable: true,
    writable: true
  })
}

export {}
